const musicLessonInformation = [
  {
    title: 'Leo’s Pandemic Poem',
    duration: '7:06 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/LeosPoem.png',
    assetId: `ARGDefSe9IrJIVAVSOG8NV4exFxY1tkBvlcc01E9QJmA`,
    description: () => (
      <>
        <p>This song reminds young children of COVID-19 Rules.</p>
        <p>
          This song is from our book “The Peekapak Pals go Back to School with the Peekaflu.” In the book, Leo the
          Hedgehog feels nervous about going back to school amidst the Peekaflu. To help his classmates remember all the
          new rules, Leo creates a poem to help remind everyone. This song will remind young children how to stay safe
          amidst the Covid-19 pandemic.
        </p>
      </>
    ),
  },
  {
    title: 'Papa Hedgehog’s Pandemic Poem',
    duration: '8:18 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/PapaHedgehogPoem.png',
    assetId: `p8hAnhJ9uTx01RPBRFcN1Yxt7xs02v02KW9gEqEg8vzPNQ`,
    description: () => (
      <>
        <p>This song reminds young children that as things change, it’s good to share what’s on our minds.</p>
        <p>
          This song is from our book “The Peekapak Pals go Back to School with the Peekaflu.” In the book, Leo the
          Hedgehog feels nervous about going back to school amidst the Peekaflu. Papa Hedgehog teaches Leo a poem about
          the value of sharing one&apos;s feelings with others. This book will help young children learn the importance
          of sharing how they feel and discover new ways to manage their emotions.
        </p>
      </>
    ),
  },
  {
    title: 'Courage - Apollo the Brave',
    duration: '2:22 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/Courage_Music.png',
    assetId: `800YRIdDlORjCJjGdWvuKOJZ8712C47y302W6xHZqa36U`,
    description: () => (
      <>
        <p>Learn how Apollo faces his fear of swimming at Sebastians birthday party.</p>
      </>
    ),
  },
  {
    title: 'Empathy - Ines and Leo',
    duration: '1:54 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/Empathy_Music.png',
    assetId: `LdEHz5ubeZzPkrDUBor01wuituV02E5Bdl1TjxpOdw7o00`,
    description: () => (
      <>
        <p>Discover how empathy can be a powerful tool from Inés&apos; experience on her first day of school.</p>
      </>
    ),
  },
  {
    title: 'Gratitude Tree (FULL version)',
    duration: '2:12 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/Gratitude_MusicFull.png',
    assetId: `Jx6luvmi6eQQrXW3h2pGejkWQIIhBwErZk3v02VkVXng`,
    description: () => (
      <>
        <p>
          Learn about the different ways we can all show gratitude to each other. Includes walkthrough of lyrics before
          song.
        </p>
      </>
    ),
  },
  {
    title: 'Gratitude Tree (SONG ONLY)',
    duration: '0:54 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/Gratitude_MusicOnlySong.png',
    assetId: `SUWuLXlBG6mOYojrEyZZjV12Ii2kU8BJFM6vYVrOGJM`,
    description: () => (
      <>
        <p>Learn about the different ways we can all show gratitude to each other.</p>
      </>
    ),
  },
  {
    title: 'Honesty - Telling the Truth',
    duration: '1:36 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/Honesty_Music.png',
    assetId: `66c00ZjZph51jpmtyyBEAiLeH5yoFZH8db7qNlKjQIEI`,
    description: () => (
      <>
        <p>Establish the key connections between telling the truth and gaining trust.</p>
      </>
    ),
  },
  {
    title: 'Kindness - wonderlude poem',
    duration: '1:28 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/Kindness_Music.png',
    assetId: `DKwP01GvA3pT1LmUmWJQrsLN5zWVC3kGPbJOD012dNhUM`,
    description: () => (
      <>
        <p>Learn about how kindness spreads throughout Peekaville during their Winter Wonderlude.</p>
      </>
    ),
  },
  {
    title: 'Optimism - Lucia’s Treasure',
    duration: '1:42 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/Optimism_Music.png',
    assetId: `YyhNVi02IoPiM02W2Hz84kfUEXbsHJHpESW100up1Lg0074`,
    description: () => (
      <>
        <p>
          Follow Lucia on her treasure hunt where she learns the importance of thinking positively and believing in
          yourself.
        </p>
      </>
    ),
  },
  {
    title: 'Perseverance - Joyful Sound',
    duration: '1:52 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/Perseverance_Music.png',
    assetId: `IrHOyXGQZyLtxJbTU01yoYEzHD3yf7gg500jFvUbDcRYU`,
    description: () => (
      <>
        <p>Dance along with ‘A Joyful Sound’ - A chance to laugh, sing, move and dance!</p>
      </>
    ),
  },
  {
    title: 'Respect - Respectful Friends',
    duration: '1:27 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/Respect_Music.png',
    assetId: `8khHR009fgM721n5P7QLIiUcxEkXzJNzEM1CmNz00DuRM`,
    description: () => (
      <>
        <p>Learn about the importance respecting the differences and uniqueness of our friends.</p>
      </>
    ),
  },
  {
    title: 'Self Reg - My Feelings (FULL version)',
    duration: '2:50 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/SelfReg_MusicFull.png',
    assetId: `Of5STxFi73HbrJJAbqvpta1CC00a65NaH4SUjzixeqaE`,
    description: () => (
      <>
        <p>
          Discover the importance of sharing your feelings and recognizing your emotions. Includes Walkthrough of lyrics
          before song.
        </p>
      </>
    ),
  },
  {
    title: ' Self Reg - My Feelings (SONG ONLY)',
    duration: '1:20 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/SelfReg_MusicOnlySong.png',
    assetId: `GcK3wZVvqSZ71s5N0202LQ5FWz01ByhHxQ31dgGdNnsGHs`,
    description: () => (
      <>
        <p>Discover the importance of sharing your feelings and recognizing your emotions.</p>
      </>
    ),
  },
  {
    title: 'Teamwork - Building a Robot',
    duration: '1:16 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/Teamwork_Music.png',
    assetId: `4oP00rkrLAqut5fJKrRrqCAcm557gp4bmEvuOhSyPUKs`,
    description: () => (
      <>
        <p>Learn about how planning, teamwork and perseverance helps when taking on new challenges.</p>
      </>
    ),
  },
];

export default musicLessonInformation;
